import { useSelector } from 'react-redux';
import { getAutomationActionToOpen } from '@mm/state/selectors/automations';
import WidgetModel from '@mm/state/model/WidgetModel';
import { useEffect } from 'react';
import { useAutomationActions } from '@mm/state/actions/automationActions';

export const useOpenOnReady = (widget: WidgetModel, callback: Function) => {
  const actions = useAutomationActions();
  const automationAction = useSelector(getAutomationActionToOpen);

  useEffect(() => {
    if (automationAction?.widgetId === widget.id) {
      actions.removeActionToOpen(automationAction);
      callback();
    }
  }, [automationAction]);
};
